import { Box, BoxProps, Center, HStack, StackProps } from '@cardboard-ui/react';
import { GripDotsIcon } from 'components/icons';
import React from 'react';
import { DraggableProvided } from 'react-beautiful-dnd';
import { Card, CardProps } from './Card';

export interface DraggableCardProps extends CardProps {
  dragProps: DraggableProvided;
  isDragDisabled?: boolean;

  // styles are not supported by default dragHandleProps
  dragHandlePropsStyles?: BoxProps;
  cardStackStyles?: StackProps;
}

export const DraggableCard = ({
  dragProps,
  isDragDisabled,
  children,
  dragHandlePropsStyles = {},
  cardStackStyles = {},
  ...props
}: DraggableCardProps) => (
  <Box
    ref={dragProps.innerRef}
    {...dragProps.draggableProps}
    style={dragProps.draggableProps.style}
    _hover={{
      zIndex: 1,
    }}
  >
    <Card isNotClickable {...props}>
      <HStack spacing={0} {...cardStackStyles}>
        {!isDragDisabled && (
          <Center>
            <Box {...dragProps.dragHandleProps} {...dragHandlePropsStyles}>
              <GripDotsIcon cursor="grab" />
            </Box>
          </Center>
        )}
        {children}
      </HStack>
    </Card>
  </Box>
);
